<template>
	<div v-intersect="{
				handler: postIntersected,
				options: {
					threshold: [0.5]
				}
			}" :class="{'post-touched': touched}">
		<v-card
			flat :outlined="!noCard" class="wall-card" v-bind:class="{ 'wall-card--accent' : pinned, 'no-card': noCard }">
			<v-card-text ref="ref" :class="contentClass">
				<div class="mb-3 d-flex justify-content-between">
					<post-top-left :edited="edited" :post="post" :pinned="pinned" :type="type" :route-is-group="routeIsGroup"/>
					<post-top-right v-if="!post.deleted_by_user_at" :pinned="pinned" :post="post" :type="type" :simple="simple" @deleted="postDeleted" :route-is-group="routeIsGroup"/>
				</div>
				<template v-if="!post.deleted_by_user_at">
					<div v-if="post.content" class="grey--text text--darken-1 mb-2">
						<multicontent :content="post.content" :mentions="post.mention_users" :url-preview="type != 'image' && type != 'video'" />
						<!--
						<div v-if="contentIntro && !expandContent" >
							<span v-html="contentIntro"></span> <span @click="expandContent = true" class="readmore" title="Rozwiń całą zawartość">Czytaj więcej</span>
						</div>
						<div v-else v-html="contentFull"></div>
						-->
					</div>
					<div v-if="type == 'problem' && post.postable" :key="postKey">
						<div v-if="post.postable && post.postable.title" class="bold font-16">{{ post.postable.title }}</div>
						<multicontent v-if="post.postable" class="mt-2" :content="post.postable.description" :mentions="post.mention_users" :url-preview="type != 'image' && type != 'video'" />
					</div>
					<v-img v-if="type == 'image' && post.image && !hideImage"
						:src="post.image.url"
						lazy-src="@/assets/images/image-placeholder.jpg"
						max-height="400"
						max-width="100%"
						class="rounded wall-img link bg-black"
						@click="showPreview()"
					/>
					<post-video v-else-if="type === 'video' && post.video" :post="post"/>
					<post-poll v-else-if="type === 'poll' && post.postable" :simple="simple" :post="post" :postId="post.id" />
					<post-attachments v-else-if="type === 'attachment' && post.attachments" :post="post"/>
					<post-kudos v-else-if="type === 'kudos' && post.postable" :post="post" />
					<div class="mt-4"></div>
					<post-details :post="post" :simple="simple" />
					<v-divider v-if="!simple" class="my-3" />
					<div v-if="!simple">
						<div class="d-flex flex-wrap justify-content-between">
							<v-slide-group
								multiple
								show-arrows
								class="w-100"
							>
								<wall-action-button
									v-for="(button, i) in validButtons"
									:id="getButtonId(button)"
									v-bind:key="'button-' + i"

									:class="{
										'mx-auto': i !== 0 && i !== validButtons.length - 1,
										'ml-auto mr-auto': validButtons.length == 2 && i == 0 ,
										'mx-auto': validButtons.length == 2 && i == validButtons.length - 1 ,
										'mr-auto': i == 0 && validButtons.length > 2,
										'ml-auto': i == validButtons.length - 1 && validButtons.length > 2,
										'post-reaction-button' : button.type === 'like',
										'active': isButtonActive(button),
										'bg-white' : true
									}"
									:saving="button.type == 'save' && savingForLater"
									:pinned="pinned"
									:action="button.action"
									:icon="button.icon"
									:text="getButtonText(button)"
									:badge="getButtonBadge(button.type)"
									:active="button.active"
									:classes-on-active="reactionColors"
									plain
									@mouseenter.native="(button.type === 'like') ? $refs['post-reaction-buttons'].show() : null"
									@mouseleave.native="(button.type === 'like') ? $refs['post-reaction-buttons'].hide() : null"
								/>

								<post-reaction-add
									:ref="'post-reaction-buttons'"
									:attach="'post-reaction-button-' + _uid"
									:post="post"
									:nudge-top="30"
								/>
								<post-share
									ref="post-share"
									:attach="'post-share-button-' + _uid"
									:post="post"
									:nudge-top="30"
								/>
							</v-slide-group>
						</div>
						<template v-if="type === 'problem'">
							<problem-ideas v-if="showIdeas" :post="post" class="mt-3"  @added="problemIdeaAdded"/>
							<problem-solution v-if="showSolution" :post="post"/>
						</template>

						<post-comment-add
							v-if="showCommentAdd && !post.is_comments_disabled"
							:placeholder="$vuetify.lang.t('$vuetify.views.wall.post.comment.startComment')"
							:post="post.id"
							class="mt-3"
					/>
					</div>
				</template>
				<div v-else class="mt-3">
					{{ $vuetify.lang.t('$vuetify.views.wall.post.deleted') }}
				</div>

				<template v-if="!simple">
					<template v-if="showComments">
						<template v-if="comments">
							<div :id="`attach__${post.id}`"></div>
							<template v-if="post.comments && post.comments.length">
								<div class="d-flex justify-end my-3">
									<post-comment-sort :post="post" />
								</div>
								<post-comment-list
									:comments="post.comments"
									:post="post.id"
									:comments-count="post.comments_root_count"
									:post-deleted="post.deleted_by_user_at ? true : false"
								/>
							</template>
							<!--
							<div v-else class="text--grey text-center font-12 mt-2">
								Brak komentarzy
							</div>
							-->
						</template>
						<template v-else>
							<div class="grey--text grey lighten-1 font-12 font-weight-bold rounded-sm py-2 px-2 text-center mt-3">
								Komentarze do tego postu zostały wyłączone
							</div>
						</template>
					</template>
				</template>
			</v-card-text>
			<post-preview-dialog v-if="preview" @closed="preview = false" :post="post" :type="type" :simple="simple" />
		</v-card>
	</div>
</template>

<script>

import PostTopRight from "@/components/wall/post/PostTopRight";
import PostTopLeft from "@/components/wall/post/PostTopLeft";
import PostDetails from "@/components/wall/post/PostDetails";
import PostCommentAdd from "@/components/wall/post/PostCommentAdd";
import WallActionButton from "@/components/items/WallActionButton";
import PostCommentList from "@/components/wall/post/PostCommentList";
import PostPoll from "@/components/wall/post/PostPoll";
import {mapGetters} from 'vuex';
import PostVideo from '@/components/wall/post/PostVideo';
import PostAttachments from '@/components/wall/post/PostAttachments';
import { decodeMentions } from "@/functions/mentions";
import PostKudos from '@/components/wall/post/PostKudos';
import PostReactionAdd from "@/components/wall/post/PostReactionAdd";
import ProblemIdeas from '@/components/wall/post/problem/ProblemIdeas';
import ProblemSolution from '@/components/wall/post/problem/ProblemSolution'
import Multicontent from '@/components/items/Multicontent';
import PostCommentSort from '@/components/wall/post/PostCommentSort';
const PostPreviewDialog = import("@/components/wall/dialogs/PostPreviewDialog");
import PostShare from '@/components/wall/post/PostShare';
export default {
	name: "Post",
	components: {
		PostPoll,
		PostTopRight,
		PostTopLeft,
		PostDetails,
		PostCommentAdd,
		WallActionButton,
		PostCommentList,
		PostVideo,
		PostAttachments,
		PostKudos,
		PostReactionAdd,
		ProblemIdeas,
		ProblemSolution,
		Multicontent,
		PostCommentSort,
		PostPreviewDialog: () => ({
			component: PostPreviewDialog,
		}),
		PostShare
	},
	props: {
		routeIsGroup: {
			type: Boolean,
			required: false,
			default: false
		},
		post: {
			type: Object,
			required: true
		},
		simple: {
			type: Boolean,
			default: false
		},
		noCard: {
			type: Boolean,
			default: false
		},
		contentClass: {
			type: String,
			default: ''
		},
		hideImage: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			reactionText: '',
			savingForLater: false,
			isIntersecting: false,
			touched: false,
			preview: false,
			contentFull: '',
			contentIntro: '',
			trimAfter: 300,
			showSolution: false,
			showIdeas: false,
			showCommentAdd: false,
			expandContent: false,
			seen: false,
			postKey: 0,
			reactionColors: null,
			filters: ['Foo', 'Bar', 'Fizz', 'Buzz'],
			buttons: [
				{
					type: 'like',
					icon: '$like',
					text: this.reactionText,
					active: !!(this.post.my_reaction),
					action: () => {
						if (!this.post.my_reaction)
							this.$refs['post-reaction-buttons'].submitReaction('like')
						else
							this.$refs['post-reaction-buttons'].submitReaction(this.post.my_reaction.type)
					}
				},
				{
					type: 'comment',
					icon: '$comment',
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.comment'),
					active: false,
					action: () => {
						this.showSolution = false;
						this.showIdeas = false;
						this.showCommentAdd = !this.showCommentAdd;
					}
				},
				{
					type: 'share',
					icon: '$share',
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.share'),
					active: false,
					action: () => {
						this.$refs['post-share'].show();
					}
				},
				{
					type: 'idea',
					icon: '$idea',
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.idea'),
					textShort: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.ideaShort'),
					active: false,
					action: () => {
						this.showSolution = false;
						this.showCommentAdd = false;
						this.showIdeas = !this.showIdeas;
					}
				},
				{
					type: 'solution',
					icon: '$star',
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.solution'),
					textShort: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.solutionShort'),
					active: false,
					action: () => {
						this.showCommentAdd = false;
						this.showIdeas = false;
						this.showSolution = !this.showSolution;
					}
				},

			]
		}
	},
	computed: {
		...mapGetters({
			seenPosts: 'wall/seenPosts'
		}),
		showDeleteAs() {
			return false;
		},
		showComments() {
			if(this.type == 'problem') {
				if(!this.showIdeas && !this.showSolution) {
					return true;
				}
				return false;
			}
			return true;
		},
		validButtons() {
			let types = [];
			if(!this.post.deleted_by_user_at) {
				if(this.post.postable && this.type == 'problem') {
					types = ['like','comment','idea'];
					if(this.post.postable.status == 'resolved') {
						types.push('solution');
					}
				}
				else {
					types = ['like','comment','share'];
				}

				if(this.post.is_comments_disabled) {
					types.splice(1, 1);
				}

				return this.buttons.filter(x => {
					return types.indexOf(x.type) !== -1;
				})
			}
			return [];
		},
		aspectRatio() {
			return 1.7;
		},
		edited() {
			return this.post.created_at !== this.post.updated_at;
		},
		pinned: function () {
			return this.post.is_pinned
		},
		comments: function () {
			return !this.post.is_comments_disabled
		},
		type() {
			if(this.post.postable_type) {
				switch (this.post.postable_type) {
					case 'poll': {
						return 'poll';
					}
					case 'problem': {
						return 'problem';
					}
					case 'kudos': {
						return 'kudos';
					}
				}
			}

			if(this.post.image) {
				return 'image';
			}
			else if(this.post.video) {
				return 'video';
			}
			else if(this.post.attachments && this.post.attachments.length) {
				return 'attachment';
			}
			else if(this.post.is_announcement) {
				return 'announcement';
			}
			return 'post';
		}

	},
	watch: {
		'post.comments': {
			handler() {
				this.showCommentAdd = false
			},
			deep: true
		},
		'post.my_reaction': function () {
			this.checkReactionIcon();
		},
		post: {
			handler() {
				this.touched = true;
				setTimeout(() => {
					this.touched = false;
				}, 1500)
			},
			deep: true
		}
	},
	methods: {
		getReactionText() {
			if(this.post && this.post.my_reaction) {
				return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.' + this.post.my_reaction.type)
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reaction')

		},
		postDeleted() {
			this.$emit('deleted');
		},
		getButtonId(button) {
			let type = '';
			if(button.type == 'like') {
				type = 'post-reaction-button-' + this._uid
			}
			else if(button.type == 'share') {
				type = 'post-share-button-' + this._uid
			}
			console.log("TYPE BUTTOn", type)
			return type;
		},
		showPreview() {
			this.preview = true;
		},
		hidePreview() {
			this.preview = false;
		},
		checkReactionIcon() {
			let index = this.buttons.findIndex(b => b.type === 'like'),
				v = this.post.my_reaction
			if (index > -1) {
				switch (v && v.type) {
					case 'love':
						this.buttons[index].icon = '$heart-reaction'
						break
					case 'happy':
						this.buttons[index].icon = '$face-reaction'
						break
					case 'applause':
						this.buttons[index].icon = '$applause-reaction'
						break
					default:
						this.buttons[index].icon = '$like'
						break
				}
				this.buttons[index].active = !!(v)
				/*
				this.buttons[index].text = (v) ?
					this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted') : this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reaction')
					*/
			}

			console.log(v)

			if (v)
				this.reactionColors = this.$refs['post-reaction-buttons'].getTypeColor(v.type)
			else
				this.reactionColors = null

		},
		getButtonText(button) {
			if(this.type == 'problem') {
				if(this.post.postable.status == 'resolved') {
					if(button.type == 'idea') {
						return button.textShort;
					}
					if(button.type == 'solution') {
						return button.textShort;
					}
				}
			}
			if(button.type == 'like') {
				return this.getReactionText()
			}
			return button.text;
		},
		getButtonBadge(type) {
			if(this.type == 'problem') {
				if(type == 'idea') {
					return this.post.postable.problem_ideas_count
				}
				if(type == 'comment') {
					return this.post.comments_count;
				}
			}

			return null
		},
		async problemIdeaAdded(problem) {
			let post = Object.assign({}, this.post);
			this.post.postable = problem;
			this.$store.commit('wall/setPost', post);
			// this.postKey++;
		},
		isButtonActive(button) {
			if(this.type == 'problem') {
				if(button.type == 'idea' && this.showIdeas) {
					return true;
				}
				if(button.type == 'solution' && this.showSolution) {
					return true;
				}
			}
			if(button.type == 'comment' && this.showCommentAdd && !this.post.is_comments_disabled) {
				return true;
			}
			return false
		},
		checkMentions(val, users) {
			return decodeMentions(val, users)
		},
		trimmed(text) {

			return text.substring(0, this.trimAfter);
		},
		postIntersected(entries, observer, isIntersecting) {
			if(isIntersecting) {
				this.seen = true;
				this.$emit('seen', this.post.id);
				this.isIntersecting = true;
			}
			else {
				this.touched = false;
				this.isIntersecting = false;
			}
		},
		buttonActionTest() {
			alert('hej')
		},

	},
	mounted() {
		this.checkReactionIcon();
		this.getReactionText();
	},
	created() {
		console.log("POST CREATED", this.post.id)
	}
}
</script>

<style lang="scss">
	.post-reaction-button {
		position: relative;
	}
	@-webkit-keyframes pulse {
		0% {
			-webkit-box-shadow: inset 0px 0px 24px 0px rgb(224, 127, 16);
			-moz-box-shadow: inset 0px 0px 24px 0px rgb(224, 127, 16);
			box-shadow: inset 0px 0px 24px 0px rgb(224, 127, 16);
		}
		100% {
			-webkit-box-shadow: none;
			-moz-box-shadow: none;
			box-shadow: none;
		}
	}
	@keyframes pulse {
		0% {
			-webkit-box-shadow: inset 0px 0px 24px 0px var(--v-accent-lighten1);
			-moz-box-shadow: inset 0px 0px 24px 0px var(--v-accent-lighten1);
			box-shadow: inset 0px 0px 24px 0px var(--v-accent-lighten1);
		}
		100% {
			-webkit-box-shadow: none;
			-moz-box-shadow: none;
			box-shadow: none;
		}
	}
	.post-touched {
		.v-card__text {
			-webkit-box-shadow: inset 0px 0px 24px 0px var(--v-accent-lighten1);
			-moz-box-shadow: inset 0px 0px 24px 0px var(--v-accent-lighten1);
			box-shadow: inset 0px 0px 24px 0px var(--v-accent-lighten1);
			animation: pulse 2s infinite;
		}
	}
</style>
